<template lang="pug">
  grid(
    :name='$t("Payments")',
    desc='Manage Invoices & Payments'
    search
    search-placeholder='Invoices'
    :views='false'
    :checkboxes='false'
    :sort='{ PaymentDate: "desc", PaymentDateFormatted: "desc" }'
    :endpoint='api.$.invoice.payments'
    :screen='api.$.invoice.list.paymentsReceived'
    alias='PaymentList_PaymentsReceive'
    legacy
    :tabs='tabs'
    :row-classes='rowClasses'
    fit-columns
    footer
    ref='grid'
  )
</template>

<script>

import Grid from '@/components/Grid'
import model from './model.js'
import tabs from '@/components/_modules/Invoices/tabs'

export default {
  components: {
    Grid
  },
  data() {
    return {
      model,
      tabs: tabs.tabs,
      rowClasses: {
        'negative-amount': params => (params.data || {}).Amount < 0
      }
    }
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Invoice-payments-received/index.vue